type formatArgs = {
  [key: number]: string
}
export const format = (text: string, args: formatArgs): string =>
  text.replace(/{(\d+)}/g, (match, num) => (typeof args[num] !== 'undefined' ? args[num] : match))
